import {useMutation} from "@tanstack/react-query";
import {apiClient} from "../../../../lib/api-client";
import {ApiResult} from "../../../../types/ApiResult";
import {SetWorkOrderToPendingParams} from "../types/SetWorkOrderToPendingParams";

export const useSetWorkOrderToPending = (
	onSuccess: () => void,
	onError: (error: string) => void) => {

	const { mutate, isLoading } = useMutation({
		mutationFn: async (params: SetWorkOrderToPendingParams) => {
			return await apiClient.post("work-order/set-to-pending", params) as ApiResult;
		},
		onSuccess: async (result) => {
			if (result.isSuccess)
				onSuccess();
			else
				onError('Error when moving the work order to pending status: ' + result.errorMessage!);
		},
		onError(error) {
			onError(error as string);
		}
	});

	return {
		mutate, isLoading
	}
}
